import suiteService from 'qreventos-suite/services';

class SuiteConfig {
    evento:number = 658;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4SSt4d09sd2VOSjg4WkF5WUZtTS9rTT0=';
    clientId: string = 'b1369137-a8fa-42dd-aa3d-a061b34c3341-658';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  
    }
}

export default new SuiteConfig();